/* CloneAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateQuestionComponent = require("../create/CreateQuestionComponent");
const _ = require("lodash");

class CloneAction {
    constructor(logger, gameEditor, modalUserFeedback, ConfigAuditPolicy, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._activeOrgId = userSession.activeOrganization.id;
        this._ConfigAuditPolicyEntity = ConfigAuditPolicy;
        this._policyEntity = new ConfigAuditPolicy(this._activeOrgId);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._firstRun = true;

        this.run = this.run.bind(this);
        this.cloneErrorHandler = this.cloneErrorHandler.bind(this);
    }
    run() {
        const selectedPolicyId = _.get(this._activeView, "selectedRows[0]");
        if (selectedPolicyId) {
            return this._ConfigAuditPolicyEntity
                .loadConfigAuditPolicy(this._activeOrgId, selectedPolicyId, { description: true, rules: true, name: true, permissionLevel: true })
                .then((selectedPolicy) => {
                    this._selectedPolicy = selectedPolicy;

                    if (_.isEmpty(selectedPolicy)) {
                        return this.showCloneError({
                            errorMsg: "Cannot retrieve the selected Config Audit Policy",
                            errorCode: "EntityRetrieveError",
                            errorTitle: "Clone Policy Error"
                        });
                    }

                    this._policyEntity.description = this._selectedPolicy.description;
                    this._policyEntity.rules = this._selectedPolicy.rules;
                    this._policyEntity.name = this._selectedPolicy.name.trim() + "-1";
                    this._policyEntity.permissionLevel = this._selectedPolicy.permissionLevel;

                    return this.clonePolicy().catch(this.cloneErrorHandler);
                });
        } else {
            return this.showCloneError({
                errorMsg: "Missing selected Config Audit Policy",
                errorCode: "MissingEntity",
                errorTitle: "Clone Policy Error"
            });
        }
    }

    cloneErrorHandler(err) {
        if (err.userRejected) {
            return this._modalUserFeedback.hideDisplayed();
        }
        this._logger.warn({ error: err }, "Clone action error.");
        const errorCode = err && err.errorCode;
        switch (errorCode) {
            case "EntityAlreadyExists":
                if (this._firstRun) {
                    this._firstRun = false;
                    return this.requestPolicyName(false);
                }
                return this.requestPolicyName(true);
            default:
                return this.showCloneError(err);
        }
    }

    showCloneError(error) {
        return this._modalUserFeedback.displayError({ error }).catch((error) => {
            if (error.userRejected) {
                return;
            }
            this._logger.warn({ error }, "Clone action error.");
        });
    }

    clonePolicy() {
        let newItemId;
        return this._policyEntity
            .create()
            .then((result) => {
                newItemId = result.id;
                return this._modalUserFeedback.hideDisplayed().then(() => {
                    return this.launchAuditEditor(result.id, result.properties.name);
                });
            })
            .then(() => {
                if (typeof this._activeView.resetSelection === "function") {
                    // making a small delay, to be sure the grid is updated with new item
                    _.delay(() => this._activeView.resetSelection([newItemId]), 200);
                }
                return Promise.resolve(this);
            });
    }

    requestPolicyName(isNotUniq) {
        return this._modalUserFeedback
            .displayCustom(
                new CreateQuestionComponent(
                    this._logger,
                    "Clone Policy",
                    isNotUniq
                        ? "The entered name is not unique. Please specify a unique name for this cloned policy."
                        : "Please specify a unique name for this cloned policy."
                ),
                { dontHide: true }
            )
            .then((result) => {
                return this._modalUserFeedback.displayLoading().then(() => {
                    this._policyEntity.name = result.trim();
                    return this.clonePolicy();
                });
            })
            .catch((err) => {
                return this.cloneErrorHandler(err);
            });
    }

    launchAuditEditor(id, name) {
        if (!id) {
            throw "Policy creation error, invalid policy id.";
        }
        let editorState = {
            fqn: Registrations.AUDIT_POLICY_EDITOR_VIEW_DETAILS,
            viewState: { createMode: true }
        };
        let launchOpts = { id: id, title: name };
        return this._gameEditor.launchAuditEditor(editorState, launchOpts);
    }
}

module.exports = CloneAction;

CloneAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.ConfigAuditPolicy",
    "$teve.userSession",
    "gameEditor.activeView"
];

CloneAction.$displayDetails = {
    type: "Action",
    name: "CloneAction",
    icon: "common.duplicate",
    title: "Clone policy",
    shown: true,
    order: 2
};
